export enum FoodOrderStatusEnum {
  PENDING = 1,
  CONFIRMED = 2,
  PREPARING = 3,
  READY = 4,
  ASSIGNED = 5,
  PICKED_UP = 6,
  DELIVERED = 7,
  CANCELLED = 8,
  REJECTED = 9,
  EXPIRED = 10,
}

export interface FoodOrderStatusConfig {
  statusId: FoodOrderStatusEnum;
  name: string;
  color: string;
}

export const FOOD_ORDER_STATUS_CONFIG: Record<FoodOrderStatusEnum, FoodOrderStatusConfig> = {
  [FoodOrderStatusEnum.PENDING]: {
    statusId: FoodOrderStatusEnum.PENDING,
    name: 'Pendiente',
    color: '#f59e0b',
  },
  [FoodOrderStatusEnum.CONFIRMED]: {
    statusId: FoodOrderStatusEnum.CONFIRMED,
    name: 'Confirmado',
    color: '#3b82f6',
  },
  [FoodOrderStatusEnum.PREPARING]: {
    statusId: FoodOrderStatusEnum.PREPARING,
    name: 'Preparando',
    color: '#8b5cf6',
  },
  [FoodOrderStatusEnum.READY]: {
    statusId: FoodOrderStatusEnum.READY,
    name: 'Listo',
    color: '#10b981',
  },
  [FoodOrderStatusEnum.ASSIGNED]: {
    statusId: FoodOrderStatusEnum.ASSIGNED,
    name: 'Asignado',
    color: '#06b6d4',
  },
  [FoodOrderStatusEnum.PICKED_UP]: {
    statusId: FoodOrderStatusEnum.PICKED_UP,
    name: 'Recogido',
    color: '#0ea5e9',
  },
  [FoodOrderStatusEnum.DELIVERED]: {
    statusId: FoodOrderStatusEnum.DELIVERED,
    name: 'Entregado',
    color: '#16a34a',
  },
  [FoodOrderStatusEnum.CANCELLED]: {
    statusId: FoodOrderStatusEnum.CANCELLED,
    name: 'Cancelado',
    color: '#ef4444',
  },
  [FoodOrderStatusEnum.REJECTED]: {
    statusId: FoodOrderStatusEnum.REJECTED,
    name: 'Rechazado',
    color: '#dc2626',
  },
  [FoodOrderStatusEnum.EXPIRED]: {
    statusId: FoodOrderStatusEnum.EXPIRED,
    name: 'Expirado',
    color: '#f97316',
  },
};

export const ACTIVE_FOOD_ORDER_STATUS_IDS: FoodOrderStatusEnum[] = [
  FoodOrderStatusEnum.PENDING,
  FoodOrderStatusEnum.CONFIRMED,
  FoodOrderStatusEnum.PREPARING,
  FoodOrderStatusEnum.READY,
  FoodOrderStatusEnum.ASSIGNED,
  FoodOrderStatusEnum.PICKED_UP,
];

export const TERMINAL_FOOD_ORDER_STATUS_IDS: FoodOrderStatusEnum[] = [
  FoodOrderStatusEnum.DELIVERED,
  FoodOrderStatusEnum.CANCELLED,
  FoodOrderStatusEnum.REJECTED,
  FoodOrderStatusEnum.EXPIRED,
];
